import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql, Link } from "gatsby";

import GlobalStyle from "../../assets/globalStyles";
import Seo from "../../components/seo";
import { SITE_NAME, canonicalUrl } from "../../seo/build-seo";

import ContainerDefault from "../../components/container";
import Header from "../../components/header";
import Footer from "../../components/footer";
import ProjectCard from "../../components/project-card";
import Newsletter from "../../components/newsletter";

import FilterProjects from "./filter";

import api from "../../services/api";
import Project from "../Project";
import { position } from "polished";

const Container = styled.section`
  padding-top: 45px;
  padding-bottom: 35px;

  h2.not-found {
    font: italic bold 32px "Times new roman";
  }

  .projects-list {
    li {
      margin-bottom: 35px;
    }
  }

  .view-more {
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      width: 265px;
    }
  }

  .loadMore {
    width: 265px;
    height: 60px;
    border-radius: 3px;

    cursor: pointer;

    background: #f1a857;

    display: flex;
    align-items: center;

    transition: 0.2s all ease;

    span {
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
      padding-left: 29px;
      padding-right: 17px;

      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    i {
      width: 55px;
      height: 100%;
      border-left: 1px solid #d99440;
      margin-left: auto;
      background: url("/images/icon-plus-white.svg") center no-repeat;
    }

    &:hover {
      background: #e59134;

      i {
        border-left: 1px solid #cd8226;
      }
    }
  }

  @media (min-width: 767px) {
    padding-bottom: 45px;
    padding-top: 45px;

    .projects-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 16px;
      grid-row-gap: 22px;

      li {
        margin-bottom: 0;
      }
    }

    .view-more {
      margin-top: 45px;
    }

    .ReactModal__Content {
      padding: 35px !important;
      left: 40px !important;
      right: 40px !important;
    }
  }

  @media (min-width: 1200px) {
    padding-top: 35px;

    .projects-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 16px;
      grid-row-gap: 28px;
    }

    .ReactModal__Content {
      padding: 35px 100px !important;
      max-width: 1200px;
      margin: 0 auto;
    }
  }

  .ReactModal__Content {
    left: 20px !important;
    right: 20px !important;
    border: 0 !important;
  }
`;

const projectsPerPage = 9;
let projectModal = false;
let arrayForHoldingProjects = [];
let allProjects = [];

export default function Projects(props) {
  const results = useStaticQuery(graphql`
    {
      seo: prismicSeoPaginaAmbientesMeuAmbiente {
        data {
          canonical {
            url
          }
          meta_description
          meta_og_description
          meta_og_image {
            url
          }
          meta_og_title
          meta_og_type
          meta_og_url {
            url
          }
          meta_title
        }
      }
    }
  `);

  // O documento de SEO desta página pode não existir no Prismic.
  const seoData = (results.seo && results.seo.data) || {};

  const [tipo, setTipo] = useState("");
  const [design, setDesign] = useState("");
  const [tonalidade, setTonalidade] = useState("");
  const [mdf, setMdf] = useState("");
  const [linha, setLinha] = useState("");
  const [is_3d, setIs3d] = useState("");
  const [loaded, setLoaded] = useState(0);
  const [projectsToShow, setProjectsToShow] = useState([]);
  const [hideLoadButton, setHideLoadButton] = useState(false);
  const [next, setNext] = useState(9);
  const [projectModal, setProjectModal] = useState(false);

  function parseFiltersFromURL() {
    // URLSearchParams decodes %XX and turns "+" into a space; manual split()/decodeURIComponent
    // left "+" literal, so "Fresno+Coimbra" never matched "fresno coimbra" on direct page load.
    const params = new URLSearchParams(window.location.search);
    const get = (k) => {
      const v = params.get(k);
      return v && v !== "undefined" ? v : "";
    };
    return {
      tipo: get("tipo-de-projeto"),
      design: get("design"),
      tonalidade: get("tonalidade"),
      mdf: get("mdf"),
      linha: get("linha"),
      is_3d: get("is_3d"),
    };
  }

  function fetchAndFilter({ tipo, design, tonalidade, mdf, linha, is_3d }) {
    setMdf(mdf);
    setTonalidade(tonalidade);
    setDesign(design);
    setTipo(tipo);
    setLinha(linha);
    setIs3d(is_3d);

    const doFetch = () => {
      api
        .post("https://apimeuambiente.guararapes.com.br/project/get/all/", {
          tipo: "",
          design: "",
          tonalidade: "",
          mdf: "",
          is_3d: "",
        })
        .then((response) => {
          allProjects = response.data;
          arrayForHoldingProjects = [];
          loopWithSlice(0, projectsPerPage, tipo, design, tonalidade, mdf, linha, is_3d);
        })
        .catch((err) => {
          // without this the page is stuck on "Carregando projetos..." forever and the real cause is invisible
          console.error("Falha ao carregar projetos:", err);
          setLoaded(1);
        });
    };

    if (allProjects.length > 0) {
      arrayForHoldingProjects = [];
      loopWithSlice(0, projectsPerPage, tipo, design, tonalidade, mdf, linha, is_3d);
    } else {
      doFetch();
    }
  }

  function handleFilterChange(updated) {
    setNext(9);
    fetchAndFilter({
      tipo: updated.tipo,
      design: updated.design,
      tonalidade: updated.tonalidade,
      mdf: updated.mdf,
      linha: updated.linha,
      is_3d: updated.is3d,
    });
  }

  useEffect(() => {
    fetchAndFilter(parseFiltersFromURL());
  }, [props]);

  const multiMatch = (param, field) =>
    param.split(",").filter(Boolean).some((v) =>
      field.toLowerCase().trim() === v.toLowerCase().trim()
    );

  const multiMatchSubstring = (param, field) =>
    param.split(",").filter(Boolean).some((v) =>
      field.toLowerCase().indexOf(v.toLowerCase().trim()) !== -1
    );

  const matchLinha = (linha, productsRaw) => {
    try {
      const prods = typeof productsRaw === "string" ? JSON.parse(productsRaw) : productsRaw;
      const uids = prods.map((p) => p?.node?.data?.categoria_produto?.uid).filter(Boolean);
      return linha.split(",").filter(Boolean).some((v) =>
        uids.some((uid) => uid.toLowerCase() === v.toLowerCase().trim())
      );
    } catch { return false; }
  };

  const loopWithSlice = (start, end, tipo, design, tonalidade, mdf, linha, is_3d) => {
    let projectsFiltered = allProjects;
    if (
      tipo.length > 0 ||
      design.length > 0 ||
      tonalidade.length > 0 ||
      mdf.length > 0 ||
      linha.length > 0 ||
      is_3d.length > 0
    ) {
      projectsFiltered = allProjects.filter(
        (item) =>
          (tipo.length > 0 && multiMatch(tipo, item.project_type)) ||
          (design.length > 0 && multiMatchSubstring(design, item.products)) ||
          (tonalidade.length > 0 && multiMatchSubstring(tonalidade, item.products)) ||
          (mdf.length > 0 && multiMatchSubstring(mdf, item.products)) ||
          (linha.length > 0 && matchLinha(linha, item.products)) ||
          (is_3d.length > 0 && item.is_3d === is_3d)
      );
    }
    const slicedProjects = projectsFiltered.slice(start, end);
    arrayForHoldingProjects = [...arrayForHoldingProjects, ...slicedProjects];
    setProjectsToShow(arrayForHoldingProjects);

    if (arrayForHoldingProjects.length === allProjects.length) {
      setHideLoadButton(true);
    }
    setLoaded(1);
  };

  const handleShowMoreProjects = () => {
    const { tipo, design, tonalidade, mdf, linha, is_3d } = parseFiltersFromURL();
    loopWithSlice(
      next,
      next + projectsPerPage,
      tipo,
      design,
      tonalidade,
      mdf,
      linha,
      is_3d
    );
    setNext(next + projectsPerPage);
  };

  const handleShowModal = (project) => {
    setProjectModal(project);
  };

  return (
    <>
      <Seo
        metaTitle={seoData.meta_title || `Ambientes | ${SITE_NAME}`}
        metaDescription={seoData.meta_description}
        title={seoData.meta_og_title}
        description={seoData.meta_og_description}
        image={seoData.meta_og_image ? seoData.meta_og_image.url : ""}
        canonical={canonicalUrl("ambientes")}
        type={seoData.meta_og_type}
      />
      <Header />
      <FilterProjects
        tipo={tipo}
        design={design}
        tonalidade={tonalidade}
        mdfFilter={mdf}
        linha={linha}
        is3d={is_3d}
        onFilterChange={handleFilterChange}
      />
      {projectModal !== false && (
        <div
          onClick={(event) => {
            if (event.target.id === "modal-background") {
              handleShowModal(false);
            }
          }}
          className="ReactModal__Overlay ReactModal__Overlay--after-open"
          id="modal-background"
          style={{
            position: "fixed",
            inset: "0px",
            backgroundColor: "rgba(0,0,0,0.6)!important",
            zIndex: 11,
          }}
        >
          <div
            className="ReactModal__Content ReactModal__Content--after-open"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            style={{
              position: "absolute",
              inset: "40px",
              border: "0px !important",
              background: "rgb(255, 255, 255)",
              overflow: "auto",
              borderRadius: "4px",
              outline: "none",
            }}
          >
            <Link to="#" className="close-modal">
              <i></i>
            </Link>
            <Project
              pageContext={projectModal}
              modalProp={true}
              modalCloseCallBack={handleShowModal}
            />
          </div>
        </div>
      )}
      <ContainerDefault>
        <Container>
          {projectsToShow.length > 0 ? (
            <ul className="projects-list">
              {projectsToShow.map((project) => (
                <li
                  key={project.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowModal(project);
                  }}
                >
                  <ProjectCard
                    id={project.id}
                    image={project.gallery}
                    name={project.name}
                    city={project.city}
                    uf={project.uf}
                    authorImage={project.user.company_avatar}
                    authorName={project.user.company_name}
                    numberOfLikes={project.likes}
                    products={project.products}
                    noLink={true}
                  />
                </li>
              ))}
            </ul>
          ) : loaded === 0 ? (
            <h2 className="not-found">Carregando projetos...</h2>
          ) : (
            <h2 className="not-found">Nenhum projeto encontrado</h2>
          )}

          <div className="view-more">
            {!hideLoadButton && projectsToShow.length > 0 && (
              <button
                type="button"
                className="loadMore"
                onClick={handleShowMoreProjects}
              >
                <span>Carregar Mais</span>
                <i></i>
              </button>
            )}
          </div>
        </Container>
      </ContainerDefault>
      <Newsletter />
      <Footer />

      <GlobalStyle />
    </>
  );
}
